import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Mirrors the shape of <ExploreCard /> so the loading state on Explore feels
 * like real cards instead of bare gray rectangles. Uses the same fixed
 * aspect ratio (1344x768) as real generated images so there's no layout jump
 * when skeletons are swapped for real cards.
 */
export const ExploreCardSkeleton = () => (
  <Card className="break-inside-avoid mb-4 overflow-hidden border border-border/50">
    <Skeleton className="w-full aspect-[1344/768] rounded-none" />
    <div className="p-3 space-y-1.5">
      <Skeleton className="h-2 w-16" />
      <div className="flex items-center gap-1.5">
        <Skeleton className="h-4 w-16 rounded-full" />
        <Skeleton className="h-4 w-12 rounded-full" />
      </div>
      <Skeleton className="h-3 w-24" />
      <div className="flex items-center justify-end gap-1 pt-1">
        <Skeleton className="h-6 w-8" />
        <Skeleton className="h-6 w-6" />
        <Skeleton className="h-6 w-6" />
      </div>
    </div>
  </Card>
);

/** Render N skeleton cards. All share the same image aspect ratio. */
export const ExploreCardSkeletonGrid = ({ count = 12 }: { count?: number }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <ExploreCardSkeleton key={i} />
    ))}
  </>
);
